module.exports = __webpack_public_path__ + "media/bootstrap-icons/question-a42cf320.svg";